import React from 'react';
import { BoundSelect } from "../BoundSelect";
import { GateEventType } from "../../../../constants/securspace-constants";

type BoundGateEventTypeSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundGateEventTypeSelect = <T,>({
  label = "Event Type",
  name,
  value = '',
  onChange
}: BoundGateEventTypeSelectProps<T>) => {

  return <BoundSelect<T>
    options={GateEventType}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundGateEventTypeSelect };